import dayjs from 'dayjs';
import { Http } from '@/lib/http';

export class ActionItemsService extends Http {
  constructor() {
    super();
    this.endpoint = 'settings/system-settings/action-items';
  }

  /**
   * Get action items for the logged in user
   * @param { Object } action item
   */
  getActionItemsForLoggedInUser() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  /**
   * Store an item in the ignore list
   * @param { Object } action item
   */
  addToIgnoreList(item) {
    let actionItems = {};

    try {
      actionItems = JSON.parse(
        localStorage.getItem('app:ignored-action-items')
      );
    } catch {}

    actionItems = {
      ...actionItems,
      [item.hash]: { ...item, date: new Date() }
    };

    localStorage.setItem(
      'app:ignored-action-items',
      JSON.stringify(actionItems)
    );
  }

  /**
   * Get all action items stored in the ignored list
   */
  getIgnoreList() {
    let actionItems = {};

    try {
      const data = localStorage.getItem('app:ignored-action-items');
      if (!data) return actionItems;

      actionItems = JSON.parse(data);
      for (const key in actionItems) {
        if (dayjs(actionItems[key].date).day() > dayjs().day()) {
          delete actionItems[key];
        }
      }
    } catch (e) {
      console.log(e);
    }

    return actionItems;
  }
  /**
   * Set action items to cool down for 8 hours
   */
  coolDownForOneHour() {
    const timeout = dayjs().add(8, 'hour').toISOString();
    localStorage.setItem('app:action-items-cooldown', timeout);
  }

  /**
 * Return true if action items are cooling down
 */
  isCoolingDown() {
    const timeout = localStorage.getItem('app:action-items-cooldown');

    if (!timeout) {
      return false;
    }

    const isCoolingDown = dayjs().isBefore(dayjs(timeout));

    if (!isCoolingDown) {
      localStorage.removeItem('app:action-items-cooldown');
    }

    return isCoolingDown;
  }
}
